var _defs, _path, _path2, _polygon, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXlsFiles01 = function SvgXlsFiles01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 52.49,
    y1: 186.51,
    x2: 167.69,
    y2: 41.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 44.24,
    y1: 179.97,
    x2: 159.44,
    y2: 34.84,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 26.82,
    y1: 166.14,
    x2: 142.02,
    y2: 21.01,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 8.31,
    y1: 151.45,
    x2: 123.51,
    y2: 6.32,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M193.16,54.12L142.2,1.18c-.73-.75-1.73-1.18-2.77-1.18H63.49c-8.5,0-15.41,6.91-15.41,15.41v53.82h-30.78c-6.36,0-11.53,5.17-11.53,11.53v57.71c0,6.36,5.17,11.53,11.53,11.53h30.78v34.62c0,8.48,6.91,15.38,15.41,15.38h115.33c8.5,0,15.41-6.9,15.41-15.37V56.79c0-.99-.39-1.95-1.08-2.67ZM140.38,10.38l41.83,43.46h-41.83V10.38ZM17.3,142.31c-2.12,0-3.84-1.72-3.84-3.84v-57.71c0-2.12,1.72-3.84,3.84-3.84h103.86c2.12,0,3.84,1.72,3.84,3.84v57.71c0,2.12-1.72,3.84-3.84,3.84H17.3ZM186.54,184.63c0,4.23-3.46,7.68-7.72,7.68H63.49c-4.26,0-7.72-3.45-7.72-7.69v-34.62h65.39c6.36,0,11.53-5.17,11.53-11.53v-57.71c0-6.36-5.17-11.53-11.53-11.53H55.77V15.41c0-4.25,3.46-7.71,7.72-7.71h69.2v50c0,2.12,1.72,3.85,3.85,3.85h50v123.09Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.54,108.68c-1.56-.82-3.95-1.61-7.2-2.38-3.25-.77-5.29-1.5-6.13-2.21-.66-.56-.99-1.23-.99-2.01,0-.86.35-1.54,1.06-2.05,1.1-.8,2.61-1.19,4.55-1.19s3.29.37,4.23,1.12c.94.74,1.55,1.96,1.84,3.66l6.67-.29c-.1-3.03-1.2-5.46-3.3-7.28-2.1-1.82-5.22-2.73-9.36-2.73-2.54,0-4.71.38-6.5,1.15-1.8.77-3.17,1.88-4.12,3.35-.95,1.47-1.43,3.04-1.43,4.72,0,2.61,1.01,4.83,3.04,6.65,1.44,1.29,3.95,2.38,7.53,3.27,2.78.69,4.56,1.17,5.34,1.44,1.14.41,1.94.88,2.4,1.43.46.55.69,1.21.69,2,0,1.22-.54,2.28-1.63,3.19-1.09.91-2.71,1.36-4.86,1.36-2.03,0-3.64-.51-4.83-1.53-1.19-1.02-1.99-2.62-2.38-4.8l-6.49.63c.44,3.7,1.77,6.51,4.01,8.44,2.24,1.93,5.45,2.9,9.62,2.9,2.87,0,5.27-.4,7.19-1.21,1.92-.8,3.41-2.03,4.46-3.68,1.05-1.65,1.58-3.43,1.58-5.32,0-2.09-.44-3.84-1.32-5.26-.88-1.42-2.1-2.54-3.65-3.36Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "65.99 94.16 59.32 94.16 59.32 126.92 82.58 126.92 82.58 121.36 65.99 121.36 65.99 94.16"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "54.7 93.89 46.97 93.89 40.48 104.5 33.86 93.89 26.06 93.89 36.29 109.68 25 126.92 33 126.92 40.35 115.5 47.67 126.92 55.72 126.92 44.43 109.93 54.7 93.89"
  })));
};
export default SvgXlsFiles01;